module.exports = __webpack_public_path__ + "static/img/end.e5e0c696.jpg";